import axios from './HTTP'

export default {
  checkAutoCallin(params) {
    return axios.post(`/api/shifts/check_auto_callin.json`, {
        shift: {
          details: params.details,
          requesting_user_id: params.userId,
          position_id: params.positionId,
          new_grads_allowed: params.allowNewGrads,
          advanced_assistants_required: params.requireAdvancedAssistants,
          location_id: params.locationId,
          start_datetime: params.shiftStart,
          end_datetime: params.shiftEnd,
          straight_bonus_amount: params.straightBonusAmount,
          call_in_bonus_amount: params.callInBonusAmount,
          travel_bonus_amount: params.travelBonusAmount,
          has_cover_bonus: params.hasCoverBonus,
          user_id: params.assignedUserId,
          repeats: params.repeats,
          repeat_frequency: params.repeatFrequency,
          repeat_until: params.repeatDuration,
          required_skill_ids: params.requiredSkillIds,
        }
    })
  },

  getAll (userId, callback) {
    axios
      .get('/api/shifts.json', {
        params: {
          user_id: userId
        }
      })
      .then(response => ( callback(response.data) ))
  },

  getList (params, callback, errorCallback) {
    axios
      .get('/api/shifts/list.json', {
        params: params
      })
      .then(response => ( callback(response.data) ))
      .catch(response => ( errorCallback(response) ))
  },

  getUpcomingFor (userId, callback) {
    axios
      .get('/api/shifts/upcoming_for_user.json', {
        params: {
          user_id: userId
        }
      })
      .then(response => ( callback(response.data) ))
  },

  getUpcomingForCurrent (callback) {
    axios
      .get('/api/shifts/upcoming_for_current_user.json')
      .then(response => ( callback(response.data) ))
  },

  getCurrentUserPickupable (callback) {
    axios
      .get('/api/shifts/pickupable_for_current_user.json')
      .then(response => ( callback(response.data) ))
  },

  getCurrentUserTwoDays (callback) {
    axios
      .get('/api/shifts/two_day_upcoming_for.json')
      .then(response => ( callback(response.data) ))
  },

  getCurrentForClient (userId, callback) {
    axios
      .get('/api/shifts/client_current.json', { params: { client_id: userId } })
      .then(response => ( callback(response.data) ))
  },

  getCurrentForAdmin (userId, callback) {
    axios
      .get('/api/shifts/admin_current.json', { params: { admin_id: userId } })
      .then(response => ( callback(response.data) ))
  },

  getWorkHistory (params, callback) {
    axios
      .get('/api/shifts/work_history.json', { params })
      .then(response => ( callback(response.data) ))
  },

  getMonth (dateInMilliseconds, callback) {
    axios
      .get('/api/shifts.json', {
        params: {
          byMonthAround: dateInMilliseconds,
        }
      })
      .then(response => ( callback(response.data) ))
  },

  getFromTo (params, callback) {
    axios
      .get('/api/shifts.json', {
        params: {
          user_id: params.userId,
          from: params.start,
          to: params.end,
        }
      })
      .then(response => ( callback(response.data) ))
  },

  getShift (shiftId, callback, errorCallback) {
    axios
      .get(`/api/shifts/${ shiftId }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  getNotes (params, callback, errorCallback) {
    axios
      .get(`/api/shift_notes.json`, {
        params: {
          shift_id: params.shiftId
        }
      })
      .then(response => ( callback(response.data) ))
      .catch(err => ( errorCallback(err) ))
  },

  update (idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/shifts/${ idAndFields.id }.json`, idAndFields)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  bulkEdit (payload, callback, errorCallback) {
    axios
      .patch(`/api/shifts/bulk.json`, {
        shift_ids: payload.shiftIDs,
        bulk_param_attributes: payload.params
      })
      .then(response => {
        callback(response.data.shifts)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  checkRestricted(params, callback, errorCallback) {
    axios
      .get(`/api/shifts/${ params.shiftId }/restricted.json`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  createNote (params, callback, errorCallback) {
    axios
      .post(`/api/shift_notes.json`, {
        shift_note: {
          shift_id: params.shiftId,
          user_id: params.userId,
          note: params.note
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  updateNote (idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/shift_notes/${ idAndFields.id }.json`, idAndFields)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  sendPickUpNotification (params, callback, errorCallback) {
    axios
      .patch(`/api/shifts/${ params.shiftId }/notify_employee_pickup.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  pickUp (params, callback, errorCallback) {
    axios
      .patch(`/api/shifts/${ params.shiftId }/pick_up.json`, {
        user_id: params.userId
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  trade (params, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ params.shiftId }/trade.json`, {
        trade_accept_user_id: params.tradeAcceptUserId
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  allowTrade (shiftId, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ shiftId }/allow_trade.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  refuseTrade (shiftId, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ shiftId }/refuse_trade.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  approveChanges (shiftId, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ shiftId }/approve_changes.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  denyChanges (shiftId, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ shiftId }/deny_changes.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  requestTrade (params, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ params.shiftId }/trade_request.json`, {
        shift_trade_request: {
          trade_reason: params.tradeReason
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  revokeTrade (shiftId, callback, errorCallback) {
    axios
      .delete(`/api/shifts/${ shiftId }/revoke_trade.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  destroy (params, callback, errorCallback) {
    axios
      .post(`/api/shift_destroys.json`, {
        shift_destroy: {
          shift_id: params.shiftId,
          all_recurring: params.allRecurring,
          only_after: params.onlyAfter
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  approve (params, callback, errorCallback) {
    axios
      .post('/api/shift_approvals.json', {
        shift_approval: {
          shift_id: params.shiftId,
          all_recurring: params.allRecurring,
          only_after: params.onlyAfter
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  cancellationDetails (params, callback, errorCallback) {
    axios
      .get(`/api/shifts/${ params.shiftId }/cancellation_details`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  cancel (params, callback, errorCallback) {
    axios
      .post(`/api/shift_cancellations`, {
        cancellation: {
          shift_id: params.shiftId,
          notes: params.notes,
        },
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  disapprove (params, callback, errorCallback) {
    axios
      .post(`/api/shift_disapprovals.json`, {
        shift_disapproval: {
          shift_id: params.shiftId,
          all_recurring: params.allRecurring,
          only_after: params.onlyAfter
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  getNewRequestPreferences (worksiteID, callback, errorCallback) {
    axios
      .get(
        '/api/new_request_preferences.json',
        { params: { worksite_id: worksiteID } }
      )
      .then(response => ( callback(response.data) ))
      // .catch(error => ( errorCallback(error) ))
  },

  saveNewRequestPreferences (params, callback, errorCallback) {
    axios
      .post(
        '/api/new_request_preferences.json',
        {
          worksite_id: params.worksiteID,
          skills: params.skillSet
        }
      )
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/shifts.json`, {
        shift: {
          details: params.details,
          requesting_user_id: params.userId,
          position_id: params.positionId,
          new_grads_allowed: params.allowNewGrads,
          advanced_assistants_required: params.requireAdvancedAssistants,
          location_id: params.locationId,
          start_datetime: params.shiftStart,
          end_datetime: params.shiftEnd,
          straight_bonus_amount: params.straightBonusAmount,
          call_in_bonus_amount: params.callInBonusAmount,
          travel_bonus_amount: params.travelBonusAmount,
          has_cover_bonus: params.hasCoverBonus,
          user_id: params.assignedUserId,
          repeats: params.repeats,
          repeat_frequency: params.repeatFrequency,
          repeat_until: params.repeatDuration,
          required_skill_ids: params.requiredSkillIds,
          sunset_after: params.sunset_after,
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  bulkCreate (shifts, callback, errorCallback) {
    axios
      .post(`/api/shifts/bulk.json`, {
        shifts
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

}
